var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCameraOpen)?_c('video',{ref:"camera",staticClass:"vdo",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight,"autoplay":""},on:{"dblclick":_vm.zoomInCamera,"click":_vm.handleClick}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }